<template>
  <div class="templates">
    <MainHeader class="templates__header" title="Шаблоны"
                :number="templatesList.vacancies?.length ? templatesList.vacancies_count : ''" btnText="Новый шаблон"
                @btnClick="$router.push('/templates/new')"/>

    <div class="templates__row">
      <div class="templates__my-switch">
        <VCheckbox v-model="onlyMine"/>

        <div class="vacancies__my-switch-text">Мои</div>
      </div>

      <VDefaultInput
          v-model="search"
          placeholder="Введите название вакансии"
          border
          class="templates__search"
      >
        <template #iconLeft>
          <img src="@/assets/images/icons/search.svg" alt="search"/>
        </template>
        <template #iconRight>
          <div
              class="templates__search-clear"
              v-if="search"
              @click="clearSearch"
          >
            <img src="@/assets/images/icons/x.svg" alt="search"/>
          </div>
        </template>
      </VDefaultInput>
    </div>

    <div class="templates__content" v-if="!errorGet ">
      <div v-if="!skeleton && templatesList.vacancies && templatesList.vacancies.length" class="templates__cards-wrapper">
        <div class="templates__cards">
          <TemplateCard class="templates__card" v-for="vacancy in templatesList.vacancies" :key="vacancy.id"
                        :vacancy="vacancy" @createVacancy="onCreateVacancy"/>

        </div>
      </div>

      <div v-if="skeleton" class="templates__cards-wrapper">
        <div class="templates__cards">
          <VSkeleton  v-for="item in  [...Array(9).keys()]" height="153" variants="CARD"/>
        </div>
      </div>

      <div class="templates__no-content" v-if="templatesList.vacancies && !templatesList.vacancies.length">
        <VNoContent title="Список шаблонов пуст" description="Вы еще не добавили шаблоны"/>
      </div>
      <div
          class="templates__pagination"
          v-if="templatesList.vacancies && templatesList.pages_count > 1 && templatesList.vacancies.length"
      >
        <VButtonNew
            class="templates__pagination-btn"
            label="Загрузить еще"
            @click="loadMore()"
            v-if="page < templatesList.pages_count && showPagination"
        />

        <VPaginateQuery
            :pageCount="templatesList.pages_count"
            class="templates__pagination-pag"
        />
      </div>
    </div>
  </div>
  <AccessClosed v-if="templatesList.blocked_by_contract"/>
</template>

<script setup>
import {onMounted, onActivated, ref, watch} from "vue";
import {useRouter, useRoute} from "vue-router";
import {useStore} from "vuex";
import vacancies from "@/api/vacancies";
import MainHeader from "@/components/MainHeader";
import TemplateCard from "@/components/TemplateCard";
import AccessClosed from "@/components/AccessClosed"
import VacancyCard from "@/components/VacancyCard/index.vue";
import VSkeleton from "@/components/UI/VSkeleton/index.vue";

const router = useRouter()
const route = useRoute()
const errorGet = ref(false)
const templatesList = ref({})
const vacancyId = ref(route.params.id);
const vacanciesList = ref({})
const page = ref(1);
const showPagination = ref(true)
const skeleton = ref(true)

const onlyMine = ref(false)
const search = ref('')

const clearSearch = () => {
  search.value = "";
  const params = {};
  getTemplates(params)
};

const getTemplates = async (params) => {
  skeleton.value = true
  try {
    templatesList.value = await vacancies.getVacancies({
      is_template: 1,
      only_mine: onlyMine.value ? 1 : null,
      search: search.value,
      page: route.query?.page || 1,
      ...params
    })
    skeleton.value = false
  } catch (error) {
    errorGet.value = true
    console.log(error)
  }
}

const createVacancy = async () => {
  try {
    await vacancies.createVacancies(vacancyId.value);
    await router.push("/vacancies");
  } catch (error) {
    showPopupErrorModal.value = true;
    console.log(error);
  }
};

const onCreateVacancy = async (templateId) => {
  localStorage.setItem('templateId', templateId)
  router.push({
    path: `/templates/${templateId}/create`,
  })
}

onActivated(() => {
  if (route.query.update) {
    router.push('/templates')
    getTemplates()
  }
})

const loadMore = async (num) => {
  showPagination.value = false
  page.value = num ? num : page.value + 1;

  const params = {
    page: router.query?.page || 1,
    is_template: 1

  };

  try {
    const response = await vacancies.getVacancies(params)

    if (num) templatesList.value.vacancies = [];
    templatesList.value.vacancies.push(...response.vacancies);
    showPagination.value = true
  } catch (error) {
    errorGet.value = true
    console.log(error);
  }
};

watch(onlyMine, (newValue) => {
  router.replace({ query: { ...route.query, onlyMine: newValue, page: 1 } });
})

watch(search, (newValue) => {
  router.replace({ query: { ...route.query, search: newValue, page: 1 } });
})

watch(() => route.query, (newValue) => {
  getTemplates()
}, {deep: true})

const updateParamsInQuery = () => {
  onlyMine.value = route.query?.onlyMine === 'true';
  search.value = route.query?.search;
  page.value = route.query?.page || 1;
}

onMounted(() => {
  updateParamsInQuery()
  getTemplates()
})
</script>

<style scoped lang="scss">
.templates {
  padding-bottom: 30px;

  &__my-switch {
    padding: 10px 16px;
    background-color: $light-gray-1;
    border-radius: 12px;
    display: flex;
    gap: 8px;
    align-items: center;
    justify-content: center;
    width: 114px;
  }

  &__my-switch-text {
    font-size: 14px;
    font-weight: 600;
  }

  &__row {
    margin-top: 24px;
    display: flex;
    justify-content: space-between;
  }

  &__header {
    margin-top: 32px;
  }

  &__content {
    margin-top: 24px;
  }

  &__cards-wrapper {
    min-height: calc(100vh - 255px);
  }

  &__cards {
    margin-left: -32px;
    margin-top: -24px;
    display: flex;
    flex-wrap: wrap;
  }

  &__card {
    width: calc(33.3% - 32px);
    margin-top: 24px;
    margin-left: 32px;
  }

  &__pagination {
    position: relative;
    width: 100%;
    height: 48px;
    margin-top: 32px;
    display: flex;
    justify-content: center;
  }

  &__pagination-btn {
    width: 156px;
    padding: 0 10px;
    font-weight: 400;
    border-radius: 8px;
  }

  &__pagination-pag {
    position: absolute;
    top: 0;
    right: 0;
  }

  &__no-content {
    width: 100%;
    height: calc(100vh - 543px);
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
